import React, { Suspense } from 'react';
import { Routes, Route, Outlet } from "react-router-dom";

//Layouts
import NonAuthLayout from "../Layouts/NonAuthLayout";
import VerticalLayout from "../Layouts/index";

//routes
import { authProtectedRoutes, publicRoutes } from "./allRoutes";
import AuthProtected from './AuthProtected';

const fullPageSpinner = (
    <div className="d-flex justify-content-center align-items-center min-vh-100">
        <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
        </div>
    </div>
);

const contentSpinner = (
    <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '60vh' }}>
        <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
        </div>
    </div>
);

// Single shared layout — stays mounted across all protected navigations.
// Suspense is inside the layout so sidebar/header never unmount while a page lazy-loads.
const ProtectedLayout = () => (
    <AuthProtected>
        <VerticalLayout>
            <Suspense fallback={contentSpinner}>
                <Outlet />
            </Suspense>
        </VerticalLayout>
    </AuthProtected>
);

const Index = () => {
    return (
        <React.Fragment>
            <Suspense fallback={fullPageSpinner}>
                <Routes>
                    <Route>
                        {publicRoutes.map((route, idx) => (
                            <Route
                                path={route.path}
                                element={
                                    <NonAuthLayout>
                                        {route.component}
                                    </NonAuthLayout>
                                }
                                key={idx}
                            />
                        ))}
                    </Route>

                    <Route element={<ProtectedLayout />}>
                        {authProtectedRoutes.map((route, idx) => (
                            <Route
                                path={route.path}
                                element={route.component}
                                key={idx}
                            />
                        ))}
                    </Route>
                </Routes>
            </Suspense>
        </React.Fragment>
    );
};

export default Index;